import { render, staticRenderFns } from "./scPlaylistItem.vue?vue&type=template&id=588c69af&scoped=true&"
import script from "./scPlaylistItem.vue?vue&type=script&lang=js&"
export * from "./scPlaylistItem.vue?vue&type=script&lang=js&"
import style0 from "./scPlaylistItem.vue?vue&type=style&index=0&id=588c69af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c69af",
  null
  
)

export default component.exports